var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDeleteRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.026,
    height: 20.279,
    viewBox: "0 0 18.026 20.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "delete_24dp_FILL0_wght400_GRAD0_opsz24_1_",
    "data-name": "delete_24dp_FILL0_wght400_GRAD0_opsz24 (1)",
    d: "M163.38-819.721a2.17,2.17,0,0,1-1.591-.662,2.17,2.17,0,0,1-.662-1.591V-836.62H160v-2.253h5.633V-840h6.76v1.127h5.633v2.253H176.9v14.646a2.17,2.17,0,0,1-.662,1.591,2.17,2.17,0,0,1-1.591.662Zm11.266-16.9H163.38v14.646h11.266Zm-9.013,12.393h2.253v-10.14h-2.253Zm4.507,0h2.253v-10.14H170.14Zm-6.76-12.393v0Z",
    transform: "translate(-160 840)",
    fill: "#e51d28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteRed);
export default __webpack_public_path__ + "static/media/icon-delete-red.de351626a1d9d14f08ce1cbc03148497.svg";
export { ForwardRef as ReactComponent };